// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React, { Suspense } from 'react';
import { BrowserRouter } from "react-router-dom";

// import components
import TopMenu from "./modules/TopMenu/TopMenu";
import BottomMenu from "./modules/BottomMenu/BottomMenu";
import CookieInfo from "./modules/CookieInfo/CookieInfo";
import Loading from './modules/Loading/Loading';
import SiteRoutes from './modules/SiteRoutes/SiteRoutes';

function App() {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <BrowserRouter>
          <TopMenu />
          <SiteRoutes />
          <BottomMenu />
          <CookieInfo />
        </BrowserRouter>
      </Suspense>
    </>
  );
}

export default App;
